import { SVGProps, Ref, forwardRef } from 'react';

export const ListOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M5.5 4.5C4.375 4.5 4 5.25 4 6s.375 1.5 1.5 1.5S7 6.75 7 6s-.375-1.5-1.5-1.5" fill="currentColor" />
            <path
                d="M5.5 10.5c-1.125 0-1.5.75-1.5 1.5s.375 1.5 1.5 1.5S7 12.75 7 12s-.375-1.5-1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M5.5 16.5c-1.125 0-1.5.75-1.5 1.5s.375 1.5 1.5 1.5S7 18.75 7 18s-.375-1.5-1.5-1.5"
                fill="currentColor"
            />
            <path d="M9 6.9h11V5.1H9z" fill="currentColor" />
            <path d="M9 12.9h11v-1.8H9z" fill="currentColor" />
            <path d="M9 18.9h11v-1.8H9z" fill="currentColor" />
        </g>
    </svg>
));
ListOutlinedSize24Glyph.displayName = 'ListOutlinedSize24Glyph';
